import { type BrandAndFooter, type TrackingConfig } from '~/types/TrackingSettings';

import { ActionKeys } from './constants';

export const fetchTrackingConfig = () =>
  <const>{
    type: ActionKeys.FETCH_TRACKING_CONFIG,
  };

export const fetchTrackingConfigSuccess = (data: TrackingConfig) =>
  <const>{
    payload: data,
    type: ActionKeys.FETCH_TRACKING_CONFIG_SUCCESS,
  };

export const fetchTrackingConfigError = (error: string) =>
  <const>{
    payload: { error },
    type: ActionKeys.FETCH_TRACKING_CONFIG_ERROR,
  };

export const updateTrackingConfig = (payload: TrackingConfig) =>
  <const>{
    payload,
    type: ActionKeys.UPDATE_TRACKING_CONFIG,
  };

export const updateTrackingConfigSuccess = (payload: TrackingConfig) =>
  <const>{
    payload,
    type: ActionKeys.UPDATE_TRACKING_CONFIG_SUCCESS,
  };

export const updateBrandAndFooter = (payload: BrandAndFooter) =>
  <const>{
    payload,
    type: ActionKeys.UPDATE_BRAND_AND_FOOTER_SETTINGS,
  };

export const updateBrandAndFooterSuccess = (payload: BrandAndFooter) =>
  <const>{
    payload,
    type: ActionKeys.UPDATE_BRAND_AND_FOOTER_SETTINGS_SUCCESS,
  };

export const updateBrandAndFooterError = (error: string) =>
  <const>{
    payload: { error },
    type: ActionKeys.UPDATE_BRAND_AND_FOOTER_SETTINGS_ERROR,
  };

export type TrackingSettingsActions =
  | ReturnType<typeof fetchTrackingConfig>
  | ReturnType<typeof fetchTrackingConfigError>
  | ReturnType<typeof fetchTrackingConfigSuccess>
  | ReturnType<typeof updateBrandAndFooter>
  | ReturnType<typeof updateBrandAndFooterError>
  | ReturnType<typeof updateBrandAndFooterSuccess>
  | ReturnType<typeof updateTrackingConfig>
  | ReturnType<typeof updateTrackingConfigSuccess>;
